import { Link } from "react-router-dom";
import styled from "styled-components/macro";

export const TabContainer = styled.div`
  margin-top: 0.7em;
  margin-top: 1.8em;

  display: grid;
  /* grid-template-columns: repeat(7, 1fr); */
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 0.75fr 0.75fr;
`;

export const TimeBox = styled.div`
  background: #282c28;
  height: 15%;
  position: absolute;
  top: 0;
  width: 100%;
  opacity: 0;
  display: flex;
  font-size: 0.95rem;
  justify-content: space-evenly;
`;

export const TimeBoxDate = styled.div`
  top: 2%;
  position: absolute;
  background: #282828;
  color: white;
  font-size: .9em;
  width: 13%;
`;

export const ChartContainer = styled.div`
  width: 100%;
  height: 53%;
  position: relative;
`;

export const ChartImg = styled.img`
  object-fit: fill;
  width: 100%;
  height: 120%;
`;

export const GraphImg = styled.img`
height: 108%;
`;

export const TabItem = styled.button`
  background: ${({ active }) => (active ? "#1f729f" : "var(--clr-settingsbg)")};
  color: #edebeb;
  font-size: .59rem;
  /* font-size: .5rem; */

`;

export const ArrowItem = styled.button`
  background: var(--clr-settingsbg);
  color: #edebeb;
  height: 100%;
`;

export const TabLink = styled(Link)``;

export const TabLinkDiv = styled.div`
  position: absolute;
  top: 18%;
  left: 0;
  width: 15%;
  height: 80%;
  z-index: 10000;
`;

export const GraphContainer = styled.div`
  position: absolute;
  top: 17%;
  left: 0;
  width: 100%;
  height: 83%;
  z-index: 500;
`;

export const TrendMenuTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5em 0;
  margin-right: 1em;
  margin-left: 1em;
  border-bottom: 1px solid #f6f6f635;
`;

//  for TrendsMEnu/Setting Page
export const TrendMenuText = styled.div``;

export const TrendsToggleBtnStandard = styled.button`
  padding: 0.5em 1.5em;
  border: #414340;

  background: gray;

  color: #edebeb;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;

  background: ${({ active }) => (active === "Standard" ? "#1f729f" : "gray")};

  &:focus {
    /* background-color: #1f729f; */
  }
`;

export const TrendsToggleBtnCardiac = styled.button`
  padding: 0.5em 1.5em;
  border: #414340;

  color: #edebeb;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
  background: ${({ active }) => (active === "Cardiac" ? "#1f729f" : "gray")};
`;

export const ToggleSwitchContainer = styled.div``;

export const GrayBox = styled.div`
  /* height: 61.5%; */

  height: 72%;


  width: 100%;
  background: var(--clr-settingsbg);
`;

export const ToggleSwitch = styled.button`
  width: 40px;
  height: 15px;
  border-radius: 15px;
  border: none;
  background-color: gray;
  position: relative;
  cursor: pointer;

  &:before {
    content: "";
    position: absolute;
    top: -2px;
    left: ${(props) => (props.isOn ? "25px" : "-3px")};
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: white;
    transition: all 0.3s ease;
  }
`;

export const TrendBanner = styled.div`
  color: #edebeb;
  margin-top: 0.5em;
  padding: 0.25em;
  background-color: #6d6868;
  text-align: center;
  margin-left: 0.5em;
  padding-left: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
  width: 100%;
  border-radius: 7px;
`;
